interface Student {
  lastName: string;
  firstName: string;
}

export function sortByLastName(rowA: Student, rowB: Student) {
  const { lastName: lnA, firstName: fnA } = rowA;
  const { lastName: lnB, firstName: fnB } = rowB;

  if (lnA === lnB) {
    return fnA.localeCompare(fnB);
  }

  return lnA.localeCompare(lnB);
}
